import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { GetTasksRequest, GetTasksResponse } from "@rightship-tech/tasks-ui/models/tasks.models";

@autoinject()
export class MyTasksService {

    public taskBaseUrl: string = `${this.configService.config.urls.myVesselsApiUrl}/api/v1/MyTasks`;
    
    constructor(private requestClient: RequestClientService, private configService: ConfigService) { }

    public async getPendingTask(request: GetTasksRequest): Promise<GetTasksResponse> {
        try {
            if (request == null)
                request = {
                    vessels: [],
                    statuses: [],
                    rowPerPage: 10,
                    orderBy: "ASC",
                    sortBy: "Date"
                };

                if(request.vessels.length == 0 || !request.vessels) {
                    return { rowCount: 0, totalPage: 0, countByTypes: {}, result: [] };
                }
                
            return await this.requestClient.post<GetTasksResponse>(`${this.taskBaseUrl}/GetPendingTask`, null, request);
        }
        catch (e) {
            console.error(e);
        }
    }

    public async getPendingTaskCount(request: GetTasksRequest): Promise<number> {
        try {
            if (request == null)
                request = {
                    vessels: [],
                    statuses: [],
                    rowPerPage: 10,
                    orderBy: "ASC",
                    sortBy: "Date"
                };
            return await this.requestClient.post<number>(`${this.taskBaseUrl}/GetPendingTaskCount`, null, request);
        }
        catch (e) {
            console.error(e);
        }
    }

    public async getAllTask(request:GetTasksRequest): Promise<GetTasksResponse> {        
        try {
            if (request == null) 
                request = {
                    vessels: [],
                    statuses: [],
                    rowPerPage: 10,
                    orderBy: "ASC",
                    sortBy: "Date"
                };
            return await this.requestClient.post<GetTasksResponse>(`${this.taskBaseUrl}/GetTasks`, {}, request);
        }
        catch (e) {
            console.error(e);
        }        
    }
}